import React from 'react'


export default function RepresentativesAddress() {
    return (
        <div className="representativesAddress">
            <h4 className="addressTitle">Região São Paulo</h4>
            <p className="addressText">
            Nome: Vazquez Repr.man.Equip.LTDA
            Contato: (11) 4347-9966 / 99846-9455
            E-mail:  vazquezneto@uol.com.br
            Endereço: Rua das Samambaias, 429 - 
            Terra Nova I - Cep - 0920540 - 
            São Bernardo do Campo - SP
            </p>
        </div>            

    );
}